import {
  AccountPayer,
  FormValues,
  GasOptionEnum,
} from "src/components/Form/types";
import { State } from "../components/Premises/types";
import { IFormState } from "../context/FormContext";
import { getIsNSWBorderPostcode } from "src/components/Form/helpers";

export const formSectionService = {
  qldPostcodesWhitelist: [
    "4390",
    "4385",
    "4384",
    "4387",
    "4383",
    "4380",
    "4496",
    "4390",
    "4494",
  ],

  inQLDPostCodeWhitelist: (postcode: string): boolean => {
    return formSectionService.qldPostcodesWhitelist.includes(postcode);
  },

  isElectricityVisible: (
    formState: IFormState,
    selectedConnections: string[],
    isDuplicate?: boolean | false
  ): boolean => {
    if (isDuplicate) {
      return false;
    }
    if (formState.electricityService?.channel === "CLAIM") {
      return true;
    }
    if (formState.electricityService?.channel === "NETWORK") {
      return true;
    }
    if (!selectedConnections.includes("Electricity")) {
      return false;
    }
    if (!formState.state || !formState.siteDetails) {
      return false;
    }
    return (
      formState.state !== State.QLD ||
      (formState.state === State.QLD &&
        formSectionService.inQLDPostCodeWhitelist(
          formState.siteDetails.postcode
        ))
    );
  },
  // check on what conditions is internet visible
  isInternetVisible: (
    formState: IFormState,
    selectedConnections: string[],
    isDuplicate?: boolean | false
  ): boolean => {
    if (isDuplicate) {
      return false;
    }
    if (!selectedConnections.includes("Internet")) {
      return false;
    }
    if (!formState.state || !formState.siteDetails) {
      return false;
    }
    return true;
  },

  isGasVisible: (
    gasOptions: GasOptionEnum[],
    blockName: GasOptionEnum,
    draftId?: string,
    isReadOnly?: boolean,
    isDuplicate?: boolean | false
  ): boolean =>
    (((Boolean(draftId) && gasOptions.includes(blockName)) || isReadOnly) &&
      !isDuplicate) ??
    false,

  isAccountVisible: (
    values: FormValues,
    premiseId: string | null,
    homeUser: boolean,
    isDuplicate?: boolean | false
  ): boolean =>
    Boolean(
      ([
        values.electricityAccountPayer,
        values.gasLine.accountPayer,
        values.gasMeter.accountPayer,
        values.both.accountPayer,
        values.internetAccountPayer,
      ].includes(AccountPayer.SOMEONE_ELSE) ||
        homeUser) &&
        premiseId &&
        !isDuplicate
    ),

  getGasTitle: (
    state: string,
    blockName: GasOptionEnum,
    postcode: string
  ): string => {
    const isNSWBorder = getIsNSWBorderPostcode(postcode);
    if (blockName === GasOptionEnum.GAS_LINE) {
      if (state === "NSW" && !isNSWBorder) {
        return "Gas path valve";
      }
      return "Gas line";
    }
    if (blockName === GasOptionEnum.BOTH) {
      if (state === "NSW") {
        return "Gas full connection";
      }
      if (state === "QLD") {
        return "Gas line and meter";
      }
      if (state === "ACT") {
        return "Gas";
      }
    }
    if (blockName === GasOptionEnum.GAS_METER) {
      if (state === "NSW" && !isNSWBorder) {
        return "Gas meter kit";
      }
      if (["QLD", "SA", "VIC"].includes(state) || isNSWBorder) {
        return "Gas meter";
      }
    }
    return "Gas";
  },
};
